import isEmptyString from "../utils/isEmptyString";
var validDay = function validDay(value) {
  if (typeof value === "number") {
    return value >= 1 && value <= 31 ? undefined : "Valid day required";
  }
  if (isEmptyString(value)) {
    return "Day is required.";
  }
  var isValidDay = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"].includes(value);
  return isValidDay ? undefined : "Valid day required"; //eslint-disable-line
};
export default validDay;